import { render } from "./HomeGreetingCmp.vue?vue&type=template&id=2e4702f4"
import script from "./HomeGreetingCmp.vue?vue&type=script&lang=js"
export * from "./HomeGreetingCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__